<template>
    <b-row class="mb-3 mr-2">
        <b-col cols="12" class="pr-0">
            <h4>{{ $t('carrito.resumen') }}</h4>
        </b-col>
        <b-col cols="12" class="pr-0">
            <hr/>
        </b-col>
        <b-col cols="12" class="pr-0">
            <b-row>
                <b-col cols="12" class="item">
                    <span>{{ $t('carrito.numero_entradas') }}</span>
                    <span>{{ datosCompra && datosCompra.totalEntradas ? datosCompra.totalEntradas : totalEntradas }}</span>
                </b-col>
                <b-col cols="12" class="item">
                    <span>{{ $t('carrito.precio') }}</span>
                    <span>{{ (datosCompra && datosCompra.precio ? datosCompra.precio : precioTotalSinGastos) | formatear_precio }}</span>
                </b-col>
                <b-col cols="12" class="item">
                    <span>{{ $t('carrito.gastos_gestion') }}</span>
                    <span>{{ (datosCompra && datosCompra.gastosGestion ? datosCompra.gastosGestion : gastos) | formatear_precio }}</span>
                </b-col>
                <b-col cols="12" class="total-price">
                    <span>{{ $t('carrito.precio_total') }}</span>
                    <span>{{ (datosCompra && datosCompra.totalPrecio ? datosCompra.totalPrecio : precioTotalConGastos) | formatear_precio }}</span>
                </b-col>
            </b-row>
        </b-col>
        <b-col :md="active_tab === 4 || active_tab === 1 || datafono ? '12' : '6'" sm="12" class="mt-3 pr-0">
            <template v-if="datafono && datafono_data">
                <DatafonoComponent 
                    :importe="precioTotalConGastos"
                    @pagoCorrecto="procesarCompraDatafono"
                />
            </template>
            <b-btn v-else @click="continuar" :disabled="active_tab === 4" block>{{ $t(buttonTitle) }}</b-btn>
        </b-col>
        <b-col v-if="active_tab !== 4 && active_tab !== 1" md="6" sm="12" class="mt-3 pr-0">
            <b-btn @click="volver" block>{{ $t('carrito.volver') }}</b-btn>
        </b-col>
    </b-row>
</template>

<script>
    import DatafonoComponent from '@/components/backend/datafono/DatafonoComponent';

    export default {
        props: {
            datosCompra: {
                type: Object
            },
            buttonTitle: {
                type: String,
                required: true
            },
            active_tab: {
                type: Number,
                required: true
            }
        },
        methods: {
            continuar() {
                this.$emit('continuar');
            },
            volver() {
                this.$emit('volver');
            },
            procesarCompraDatafono(data) {
                this.datosCompra.datafono_response = data;

                if(this.datafono_data){
                    this.datosCompra.datafono_id = this.datafono_data.id;
                }

                this.continuar();
            }
        },
        computed: {
            totalEntradas() {
                if (this.carritoItems?.length > 0) {
                    return this.carritoItems.reduce((total, evento) => {
                        const totalItemsEvento = evento.items.reduce((suma, item) => {
                            return suma + item.units;
                        }, 0);
                        return total + totalItemsEvento;
                    }, 0);
                }

                return 0;
            },
            precioTotalSinGastos() {
                if (this.carritoItems?.length > 0) {
                    return this.carritoItems.reduce((total, evento) => {
                        const totalPrecioEvento = evento.items.reduce((suma, item) => {
                            const descuento = item.descuento ? (1 - (item.descuento.slice(-3).trim() / 100)) : 1;
                            const precioConDescuento = (item.entrada.precio ?? item.entrada.price) * descuento;

                            return suma + (item.units * precioConDescuento);
                        }, 0);
                        return total + totalPrecioEvento;
                    }, 0);
                }

                return 0;
            },
            gastos() {
                if (this.carritoItems?.length > 0) {
                    return this.carritoItems.reduce((total, evento) => {
                        const totalGastosEvento = evento.items.reduce((suma, item) => {
                            if (!item.entrada.price_management_interno) {
                                return suma + item.entrada.price_management;
                            }
                        
                            return 0;
                        }, 0);
                        return total + totalGastosEvento;
                    }, 0);
                }

                return 0;
            },
            precioTotalConGastos() {
                var importe = this.precioTotalSinGastos;

                if(this.gastos > 0) {
                    importe += this.gastos;
                }

                return importe;
            },
            carrito() {
                return this.$store.getters.getCarritoActivo;
            },
            carritoItems() {
                return this.$store.getters.getCarritoItems;
            },
            puedeUsarDatafono() {
                return this.$store.getters.getPuedeUsarDatafono;
            },
            url() {
                return window.location.href;
            },
            datafono() {
                return this.active_tab === 3 && this.url.includes('admin') && this.datosCompra.metodo_pago.id == 3 && this.puedeUsarDatafono;
            },
            datafono_data() {
                let datafono = null;
                if (this.datafono) {
                    const datafonoPropio = this.carritoItems.every(evento => evento.datafono_propio);

                    if (datafonoPropio) {
                        datafono = this.$store.getters.getUser.datafonos.find(datafono => datafono.nif == this.carritoItems[0].nif);
                    } else {
                        datafono = this.$store.getters.getUser.datafonos.find(datafono => datafono.nif == 'compralaentrada');
                    }
    
                    this.$store.dispatch('setActiveDatafono', datafono);                
                }

                return datafono;
            },
        },
        components: {
            DatafonoComponent
        }
    }
</script>

<style scoped>
.item {
    display: flex;
    justify-content: space-between;
}
.total-price {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    font-size: 24px;
    margin-top: 20px;
}
hr {
    margin-top: 0px;
    margin-bottom: 10px;
}
</style>